/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecipientCommentsWithCurrentFiltersCountQueryVariables = Types.Exact<{
  processingStatuses?: Types.InputMaybe<Array<Types.Processing_Status> | Types.Processing_Status>;
  surveyContentType: Types.SurveyContentType;
}>;


export type RecipientCommentsWithCurrentFiltersCountQuery = { global: { id: string, recipientCommentsWithCurrentFiltersCount: number } };


export const RecipientCommentsWithCurrentFiltersCountDocument = gql`
    query RecipientCommentsWithCurrentFiltersCount($processingStatuses: [Processing_status!], $surveyContentType: SurveyContentType!) {
  global: getStatisticsGlobal(surveyContentType: $surveyContentType) {
    id
    recipientCommentsWithCurrentFiltersCount: number_of_recipient_comments(processing_status: $processingStatuses)
  }
}
    `;

/**
 * __useRecipientCommentsWithCurrentFiltersCountQuery__
 *
 * To run a query within a React component, call `useRecipientCommentsWithCurrentFiltersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientCommentsWithCurrentFiltersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientCommentsWithCurrentFiltersCountQuery({
 *   variables: {
 *      processingStatuses: // value for 'processingStatuses'
 *      surveyContentType: // value for 'surveyContentType'
 *   },
 * });
 */
export function useRecipientCommentsWithCurrentFiltersCountQuery(baseOptions: Apollo.QueryHookOptions<RecipientCommentsWithCurrentFiltersCountQuery, RecipientCommentsWithCurrentFiltersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecipientCommentsWithCurrentFiltersCountQuery, RecipientCommentsWithCurrentFiltersCountQueryVariables>(RecipientCommentsWithCurrentFiltersCountDocument, options);
      }
export function useRecipientCommentsWithCurrentFiltersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipientCommentsWithCurrentFiltersCountQuery, RecipientCommentsWithCurrentFiltersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecipientCommentsWithCurrentFiltersCountQuery, RecipientCommentsWithCurrentFiltersCountQueryVariables>(RecipientCommentsWithCurrentFiltersCountDocument, options);
        }
export type RecipientCommentsWithCurrentFiltersCountQueryHookResult = ReturnType<typeof useRecipientCommentsWithCurrentFiltersCountQuery>;
export type RecipientCommentsWithCurrentFiltersCountLazyQueryHookResult = ReturnType<typeof useRecipientCommentsWithCurrentFiltersCountLazyQuery>;
export type RecipientCommentsWithCurrentFiltersCountQueryResult = Apollo.QueryResult<RecipientCommentsWithCurrentFiltersCountQuery, RecipientCommentsWithCurrentFiltersCountQueryVariables>;